import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { GetFeaturesResponseType } from '../types';

export const getFeatures = async () => {
  const url = '/api/v2/features';

  const { data } = await apiAuthClient.get<GetFeaturesResponseType>(url);

  return data;
};
